export enum TagTypes {
    Member = 0,
    Designer = 1,
    License = 2,
    Invoice = 3,
    GIS = 4,
    CreditCard = 5,
    Credit = 6,
}

export enum TagTOSTypes {
    Custom = 0,
    TOS = 1,
    FormerTOS = 2,
    HasReviewed = 12
}

export interface ITagItem {
    ID: number;
    Name: string;
    Description: string;
    HexColor: string;
    forMember: boolean;
    forDesigner: boolean;
    forLicense: boolean;
    forInvoice: boolean;
    forGIS: boolean;
    forCreditCard: boolean;
    forCredit: boolean;
    Visible: boolean;
    TagTOSType: TagTOSTypes;

    // for internal use
    Selected: boolean;

}


export class TagArray extends Array<TagItem>  {

    constructor(...items: TagItem[]) {
        super(...items);
        Object.setPrototypeOf(this, TagArray.prototype);
    }

}

export class TagItem implements ITagItem {
    ID: number;
    Name: string;
    Description: string;
    HexColor: string;
    forMember: boolean;
    forDesigner: boolean;
    forLicense: boolean;
    forInvoice: boolean;
    forGIS: boolean;
    forCreditCard: boolean;
    forCredit: boolean;
    Visible: boolean;
    Selected: boolean;
    TagTOSType: TagTOSTypes;

}
